import { get } from "lodash";
import React from "react";
import { DateField as RaDateField } from "react-admin";

const DateField = ({ source, record, ...props }) => {
	const value = get(record, source, "");
	const newValue = value && value.length > 0 ? value : null;
	return (
		<RaDateField source={source} record={{ [source]: newValue }} {...props} />
	);
};

export default DateField;
